module.exports = __webpack_public_path__ + "static/media/principal.6ac4be20.jpeg";